import { render, staticRenderFns } from "./channel-delivery.pug?vue&type=template&id=52baf44e&lang=pug&"
import script from "./channel-delivery.ts?vue&type=script&lang=ts&"
export * from "./channel-delivery.ts?vue&type=script&lang=ts&"
import style0 from "./channel-delivery.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports